export default __webpack_public_path__ + "static/media/paths-color-logo.256a7d6b.png";